<template>

    <b-card-group deck>
        <event-card
                v-for="(event, idx) in events"
                :event="event" :colour="colour"
                :key="idx"
        >
        </event-card>
    </b-card-group>

</template>

<script>
    import eventCard from "./event-card.vue";

    export default {
        props: ['events', 'colour'],
        components: {
            eventCard: eventCard,
        },
    }
</script>